import "dayjs/locale/es";
import "dayjs/locale/pt-br";

import dayjs from "dayjs";
import { Locales } from "../i18n/constants";
import { parseLocale } from "../i18n/utils";

const toDayJSLocale: Record<Locales, string> = {
  [Locales.ES_PY]: "es",
  [Locales.PT_BR]: Locales.PT_BR,
};

export function setDayJSLocale(locale: string) {
  const parsedLocale = parseLocale(locale);
  const dayJSLocale = toDayJSLocale[parsedLocale];
  dayjs.locale(dayJSLocale);
}
